import { GutterCap, Header } from '@adserve/adserve-react-components';
import React, { useState } from 'react';
import AirtimeBurstsRow from './AirtimeBurstsRow';
import AirtimeBurstsTotalRow from './AirtimeBurstsTotalRow';

const AirtimeBurstsGrid = ({ campaign, campaignBursts, deleteBurst, readOnly = false }) => {
    const [scrollPx, setScrollPx] = useState(0);

    const rowHeight = 30;
    const visibleRows = 13;
    const maxVisibleHeight = rowHeight * (visibleRows + 3); // + 3 for Header rows and Total row

    const sumAllLines = (field) => {
        let total = 0;
        campaignBursts?.forEach((b) => {
            total = total + parseFloat(b[field]);
        });

        return total;
    };

    const paddingRows = () => {
        const paddingContent = [];
        for (let i = campaignBursts?.length; i < visibleRows; i++) {
            paddingContent.push(
                <AirtimeBurstsRow
                    key={i}
                    index={i}
                    scrollPx={scrollPx}
                    onScroll={setScrollPx}
                    scrollableLength={campaignBursts.length * rowHeight}
                    rowHeight={rowHeight}
                    visibleRows={visibleRows}
                    readOnly={readOnly}
                />
            );
        }
        return paddingContent;
    };

    return (
        <>
            <div
                style={{
                    width: '100%',
                    display: 'grid',
                    gridTemplateColumns: '75px 198px repeat(14, minmax(max-content, auto)) 100px 19px',
                    gridAutoRows: 30,
                    height: maxVisibleHeight,
                    overflowY: 'hidden',
                    marginTop: 34
                }}
            >
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '1 / span 2',
                        borderLeftWidth: 1,
                        justifyContent: 'flex-start',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '1 / span 2',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Burst Name')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '1 / span 2',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Version')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '1 / span 2',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Station')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '1 / span 2',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Start date')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '1 / span 2',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('End date')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '1 / span 2',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Spots')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '1 / span 1',
                        gridColumn: '8 / span 4',
                        backgroundColor: '#F7F7F7',
                        borderBottomWidth: 0
                    }}
                >
                    {window.translate('Base')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '1 / span 1',
                        gridColumn: '12 / span 4',
                        backgroundColor: '#F7F7F7',
                        borderBottomWidth: 0
                    }}
                >
                    {window.translate('Target')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '1 / span 2',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Spend')}
                </Header>
                <GutterCap
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '1 / span 2',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Status')}
                </GutterCap>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '2 / span 1',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Impacts')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '2 / span 1',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Reach %')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '2 / span 1',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Overall OTH')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '2 / span 1',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Weekly OTH')}
                </Header>

                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '2 / span 1',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Impacts')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '2 / span 1',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Reach %')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '2 / span 1',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Overall OTH')}
                </Header>
                <Header
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    style={{
                        gridRow: '2 / span 1',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingBottom: 5
                    }}
                >
                    {window.translate('Weekly OTH')}
                </Header>

                {campaignBursts?.map((burst, i) => (
                    <AirtimeBurstsRow
                        key={i}
                        index={i}
                        burst={burst}
                        scrollPx={scrollPx}
                        onScroll={setScrollPx}
                        scrollableLength={campaignBursts.length * rowHeight}
                        rowHeight={rowHeight}
                        visibleRows={visibleRows}
                        campaign={campaign}
                        deleteBurst={deleteBurst}
                        readOnly={readOnly}
                    />
                ))}
                {paddingRows()}
                <AirtimeBurstsTotalRow
                    scrollPx={campaignBursts.length >= visibleRows ? (campaignBursts.length - visibleRows) * rowHeight : 0}
                    rowHeight={rowHeight}
                    visibleRows={visibleRows}
                    sumAllLines={sumAllLines}
                    campaign={campaign}
                    burstCount={campaignBursts.length}
                />
            </div>
        </>
    );
};

export default AirtimeBurstsGrid;
